<div class="">
    <div class="page-content">
        <div class="row">
            <div class="col-6">
                <h2 class="heading1 d-none d-sm-block">{{ this.getFormSubTitle == 'Customer Master' ?  ('Language.CustomerMasterText' |translate ):
                    this.getFormSubTitle == 'Vendor Master' ? ('Language.VendorMasterText' | translate) :
                    ('Language.LeadMasterText' |translate)}} </h2>
                <h2 class="heading1 d-block d-sm-none">{{ this.getFormSubTitle == 'Customer Master' ?  ('Language.CustomerMasterText' | translate ):
                    this.getFormSubTitle == 'Vendor Master' ? ('Language.VendorMasterText' | translate) :
                    ('Language.LeadMasterText' |translate)}}</h2>    
            </div>
            <div class="col-6 text-end">
                <button *ngIf="canAdd" #buttonNewRow mat-raised-button (click)="onClickOfGenericNewButton()" class="primary-btn">
                    {{'Language.CreateNewText' | translate }}
                </button>
            </div>
        </div>
        <div class="row mt-4 d-none d-sm-flex">
            <div class="col-md-6">
                <h3 class="heading2">{{ this.getFormSubTitle == 'Customer Master' ?  ('Language.CustomerMasterText' |
                    translate ):
                    this.getFormSubTitle == 'Vendor Master' ? ('Language.VendorMasterText' | translate) :
                    ('Language.LeadMasterText' |translate)}}</h3>
            </div>
            <!-- <div class="col-md-6 text-end fs-9 mt-1">
              Customize Column
              <span class="ms-3 customize-column" (click)="openDialog()">
                  <i-feather class="t-icon" name="layers"></i-feather>
              </span>
          </div> -->
        </div>

        <div class="row">
            <div class="col-md-12 tabledesign">
                <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChip($event.index,$event.data)">
                </app-chip>
                <table mat-table [dataSource]="this.getListViewDataSource">
                    <!-- this.getListViewDataSource -->

                    <!-- S.No. Column -->
                    <!-- <ng-container matColumnDef="series_name">
                        <th mat-header-cell *matHeaderCellDef>
                            Series Number
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'series_name'" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('series_name',this.active)">
                                </app-filter>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row;let i=index;">
                            <span class="t-link">{{i+1}}</span>
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="cardCode">
                        <th mat-header-cell *matHeaderCellDef> {{ this.getFormSubTitle == 'Customer Master' ?  ('Language.CustomerCodeText' |
                            translate ):
                            this.getFormSubTitle == 'Vendor Master' ? ('Language.VendorCodeText' | translate) :
                            ('Language.LeadCodeText' |translate)}}
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'cardCode'" [colType]="'alphabets'"
                                    [labelType]="'Language.CardCodeText' | translate" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('cardCode',this.active)">
                                </app-filter>
                            </mat-menu>

                        </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.cardCode}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cardName">
                        <th mat-header-cell *matHeaderCellDef> {{ this.getFormSubTitle == 'Customer Master' ?  ('Language.CustomerNameText' |
                            translate ):
                            this.getFormSubTitle == 'Vendor Master' ? ('Language.VendorNameText' | translate) :
                            ('Language.LeadNameText' |translate)}}
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'cardName'" [colType]="'alphabets'"
                                    [labelType]="'Language.CardNameText' | translate" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('cardName',this.active)">
                                </app-filter>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.cardName}}
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="cardTypeName">
                        <th mat-header-cell *matHeaderCellDef> Card Type
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'cardTypeName'" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('cardTypeName',this.active)">
                                </app-filter>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.cardTypeName}}
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="groupName">
                        <th mat-header-cell *matHeaderCellDef> {{'Language.GroupNameText' | translate }}
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'groupName'" [colType]="'alphabets'"
                                    [labelType]="'Language.GroupNameText' | translate" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('groupName',this.active)">
                                </app-filter>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.groupName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="validName">
                        <th mat-header-cell *matHeaderCellDef> {{'Language.validNameText' | translate }}
                            <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                            <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                                <app-filter [shortColumn]="'validName'" [colType]="'BoolYN'"
                                    [labelType]="'Language.validNameText' | translate" [isActive]="this.active"
                                    (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                    (sortFilter)="this.onClickOfGenericColumnSort('validName',this.active)">
                                </app-filter>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.validName}}
                        </td>
                    </ng-container>




                    <!-- <ng-container matColumnDef="lock">
                        <th mat-header-cell *matHeaderCellDef> Lock </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox class="example-margin">
                                {{row.locked}}
                            </mat-checkbox>
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.EditText' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let row" class="text-center">
                            <!-- <mat-icon [matMenuTriggerFor]="menu1">more_vert</mat-icon>
                          <mat-menu #menu1="matMenu" class="actiontrigger" xPosition="after">
                              <mat-icon>edit</mat-icon> 
                              <span class="text-primary pe-4 fs-7" (click)="onClickOfGenericEditButton(row.bplid.toString())">Edit</span>
                              <div class="menu-item text-danger">
                                  <mat-icon>delete_outline</mat-icon> Delete
                              </div>
                          </mat-menu> -->
                            <i-feather *ngIf="canEdit || canView" class="t-icon pointer" name="{{ !canEdit && canView ? 'eye' : 'edit-2' }}"
                                (click)="onClickOfGenericEditButton(row.cardCode)">
                            </i-feather>
                            <!-- <i-feather class="t-icon ms-3" name="trash-2"></i-feather> -->
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList"></tr>
                    <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
                </table>
            </div>
            <mat-paginator #paginator class="mt-3" [length]="this.getRowCount" [pageSize]="this.getPaginatorPageSize"
                    [pageSizeOptions]="this.getPaginatorPageSizeOptions" aria-label="Select page"
                    (page)="onClickOfGenericPaginator($event)" showFirstLastButtons>
            </mat-paginator>
        </div>
    </div>
</div>